import { CatalogueContext } from 'CommonScripts/catalogueContext';
import { isInFrame } from 'CommonScripts/frameHelper';
import { GUIDHelper } from 'CommonScripts/guidHelper';

class LiveChat {
    public static setEventListeners() {
        if (CatalogueContext.isMarshallsCatalogue() && !isInFrame()) {

            // Add Front scripts to DOM
            const chatEl: HTMLDivElement = document.querySelector('.live-chat__js-button') as HTMLDivElement;
            const scriptTag1: HTMLScriptElement = document.createElement('script');
            const scriptTag2: HTMLScriptElement = document.createElement('script');
            scriptTag1.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
            scriptTag2.innerHTML = `window.FrontChat('init', { chatId: '6b87d8cdc368fffa2c546ab11a9067ab', useDefaultLauncher: false });`;
            
            if (chatEl) {
                chatEl.appendChild(scriptTag1);
                scriptTag1.onload = () => {
                    chatEl.appendChild(scriptTag2);
                };
            }

            // Open Front when live chat button clicked
            document.addEventListener('DOMContentLoaded', () => {
                const liveChatButtonEl: HTMLDivElement = document.querySelector('.live-chat__button') as HTMLDivElement;

                if (liveChatButtonEl) {
                    liveChatButtonEl.addEventListener('click', () => {
                        (window as any).FrontChat('show');
                    });
                }
            });

            // Set a new GUID for live chat
            const liveChatEl: HTMLDivElement = document.querySelector('.js-live-chat-id') as HTMLDivElement;
            if (liveChatEl) {
                liveChatEl.id = GUIDHelper.create();
            }
        } else {
            const liveChatContainerEl: HTMLDivElement = document.querySelector('.js-live-chat-container') as HTMLDivElement;
            const liveChatButtonEl: HTMLElement = document.querySelector('.js-live-chat-button') as HTMLElement;
            
            liveChatContainerEl.classList.add('hidden');
            liveChatButtonEl.classList.add('hidden');
        }
    }
}

LiveChat.setEventListeners();